import { Grid } from "@mui/material";
import { Form, Formik } from "formik";
import Swal from "sweetalert2";
import { useAppDispatch } from "../../../app/hooks";
import {
  AutocompleteDropDown,
  CreateButton,
  FormFooter,
  MetaTags,
  PageLayout,
  TextInput,
} from "../../../components";
import { useChangePasswordMutation } from "../../../features/api/Api";
import { logout } from "../../../features/auth/AuthSlice";
import useLocales from "../../../hooks/useLocales";
import useUser from "../../../hooks/useUser";
import {
  changePasswordInitials,
  IChangePasswordInitials,
} from "../../../interfaces/User";

import { validationSchema } from "./common/validations";

const ChangePassword = () => {
  const { user } = useUser();
  const { translate } = useLocales();
  const [changePassword] = useChangePasswordMutation();

  const dispatch = useAppDispatch();

  const submitHandler = (
    values: IChangePasswordInitials,
    { setSubmitting }: any
  ) => {
    const customValue = {
      password: values.password,
      oldPassword: values.oldPassword,
      email: user.email,
      // ChangePasswordPeriod: values.ChangePasswordPeriod,
      customerCode: user.customerCode,
    };

    changePassword(customValue)
      .unwrap()
      .then((data: any) => {
        Swal.fire({
          title: translate("actions.successfully"),
          text: translate("actions.password_change_success"),
          icon: "success",
          confirmButtonText: translate("actions.ok"),
        }).then((result: any) => {
          if (result.isConfirmed) {
            dispatch(logout());
          }
        });

        const removeFields = ["oldPassword", "password"];
        removeFields.map(
          (field) => delete values[field as keyof IChangePasswordInitials]
        );

        setSubmitting(false);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.data.errors,
          confirmButtonText: translate("actions.ok"),
        });
        setSubmitting(false);
      });
  };

  return (
    <>
      <MetaTags
        title="Sifre Degistir"
        keyword="Sifre Degistir"
        description="Sifre Degistir"
      />
      <PageLayout title="Şifre Yenileme">
        <div>
          <Formik
            initialValues={changePasswordInitials}
            validationSchema={validationSchema}
            onSubmit={submitHandler}
          >
            {(props) => (
              <Form>
                <Grid container spacing={3}>
                  <Grid item md={6} lg={6} xs={12} sm={12}>
                    <TextInput
                      name="oldPassword"
                      label={translate("resources.changePassword.oldPassword")}
                      type="password"
                    />
                  </Grid>
                  <Grid item md={6} lg={6} xs={12} sm={12}>
                    <TextInput
                      name="password"
                      label={translate("resources.changePassword.password")}
                      type="password"
                    />
                  </Grid>
                  <Grid item md={6} lg={6} xs={12} sm={12}>
                    <TextInput
                      name="passwordCompare"
                      label={translate(
                        "resources.changePassword.password_again"
                      )}
                      type="password"
                    />
                  </Grid>
                  {/* <Grid item md={6} lg={6} xs={12} sm={12}>
                    <AutocompleteDropDown
                      name="ChangePasswordPeriod"
                      label={translate(
                        "resources.changePassword.password_frequency"
                      )}
                      options={locale(
                        PasswordFrequencyOptions,
                        "resources.changePassword."
                      )}
                      disableClearable={true}
                    />
                  </Grid> */}
                </Grid>
                <FormFooter>
                  <CreateButton disabled={props.isSubmitting} />
                </FormFooter>
              </Form>
            )}
          </Formik>
        </div>
      </PageLayout>
    </>
  );
};

export default ChangePassword;
